export default "__VITE_ASSET__BWvPZBXv__"